import en from './messages/en.json';
import es from './messages/es.json';
import sv from './messages/sv.json';
import de from './messages/de.json';
import fr from './messages/fr.json';
import no from './messages/no.json';
import pt from './messages/pt.json';
import it from './messages/it.json';
import da from './messages/da.json';
import fi from './messages/fi.json';
import ja from './messages/ja.json';
import zh from './messages/zh.json';

export const DEFAULT_LOCALE = 'en';
type LocaleKey = 'en' | 'es' | 'sv' | 'de' | 'fr' | 'no' | 'pt' | 'it' | 'da' | 'fi' | 'ja' | 'zh';
export const MESSAGES: Record<LocaleKey, Record<string, unknown>> = {
  en,
  es,
  sv,
  de,
  fr,
  no,
  pt,
  it,
  da,
  fi,
  ja,
  zh
};

const flattenMessages = (input: Record<string, unknown>, prefix = ''): Record<string, string> => {
  const output: Record<string, string> = {};
  Object.entries(input).forEach(([key, value]) => {
    const nextKey = prefix ? `${prefix}.${key}` : key;
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      Object.assign(output, flattenMessages(value as Record<string, unknown>, nextKey));
      return;
    }
    output[nextKey] = String(value);
  });
  return output;
};

export const resolveLocale = (locale?: string): LocaleKey => {
  const normalized = (locale || '').toLowerCase();
  if (normalized.startsWith('es')) {
    return 'es';
  }
  if (normalized.startsWith('sv')) {
    return 'sv';
  }
  if (normalized.startsWith('de')) {
    return 'de';
  }
  if (normalized.startsWith('fr')) {
    return 'fr';
  }
  if (normalized.startsWith('no') || normalized.startsWith('nb') || normalized.startsWith('nn')) {
    return 'no';
  }
  if (normalized.startsWith('da')) {
    return 'da';
  }
  if (normalized.startsWith('fi')) {
    return 'fi';
  }
  if (normalized.startsWith('pt')) {
    return 'pt';
  }
  if (normalized.startsWith('it')) {
    return 'it';
  }
  if (normalized.startsWith('ja')) {
    return 'ja';
  }
  if (normalized.startsWith('zh')) {
    return 'zh';
  }
  if (normalized.startsWith('en')) {
    return 'en';
  }
  return DEFAULT_LOCALE;
};

export const getMessagesForLocale = (locale?: string) => {
  const resolved = resolveLocale(locale);
  const defaultMessages = flattenMessages(MESSAGES[DEFAULT_LOCALE] as Record<string, unknown>);
  
  // If requesting default locale, return it directly
  if (resolved === DEFAULT_LOCALE) {
    return defaultMessages;
  }
  
  // For other locales, merge with default locale for fallback
  const localeMessages = flattenMessages(MESSAGES[resolved] as Record<string, unknown>);
  
  // Merge: locale messages override default messages, but missing keys fall back to default
  return { ...defaultMessages, ...localeMessages };
};
